import type { JSX } from 'react';

interface LogoProps {
  size?: number;
  className?: string;
  title?: string;
}

export function TradingAgentLogo({
  size = 48,
  className,
  title = 'Trading Agent',
}: LogoProps): JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      className={className}
      role="img"
      aria-label={title}
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{title}</title>
      <rect x="5" y="5" width="90" height="90" rx="18" fill="#0B0D0C" />
      <line x1="25" y1="18" x2="25" y2="82" stroke="#6EE7A0" strokeWidth="2" />
      <rect x="20" y="32" width="10" height="28" fill="#6EE7A0" />
      <line x1="50" y1="30" x2="50" y2="88" stroke="#FF7878" strokeWidth="2" />
      <rect x="45" y="42" width="10" height="18" fill="#FF7878" />
      <line x1="75" y1="14" x2="75" y2="78" stroke="#6EE7A0" strokeWidth="2" />
      <rect x="70" y="22" width="10" height="36" fill="#6EE7A0" />
    </svg>
  );
}
